"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Layout = require("../Layout");

var ComponentWrapper = function ComponentWrapper(_ref) {
  var children = _ref.children,
      columnWidth = _ref.columnWidth,
      rest = _objectWithoutProperties(_ref, ["children", "columnWidth"]);

  return /*#__PURE__*/_react.default.createElement(_Layout.Container, rest, /*#__PURE__*/_react.default.createElement(_Layout.Grid, {
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_Layout.Column, {
    width: columnWidth
  }, children)));
};

ComponentWrapper.propTypes = {
  children: _propTypes.default.node.isRequired,
  columnWidth: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.string, _propTypes.default.number])
};
ComponentWrapper.defaultProps = {
  columnWidth: [12, null, 10, 8]
};
var _default = ComponentWrapper;
exports.default = _default;